export function getImageNodes(data) {
  let all = data.allFile.edges
  return all
    .map(image => ({
      src: image.node.publicURL,
      name: image.node.name,
    }))
    .sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }))
}
